import { Address, AuthUser } from '@/context/types'; // Assuming AuthUser is here too
import { ImplAPI, Req } from './ImplAPI';

interface LoginInfo {
  fullName: string;
  phone: string;
  address?: Address;
}

export interface LoginBody {
  token: string;
  info: LoginInfo;
}

export interface DefaultAddressBody {
  newAddress: Address;
  currentAddress: Address | null;
}

// Define exactly what the backend returns so your components get autocomplete
interface SyncResponse {
  isLoggedIn: boolean;
  success?: boolean;
  user: AuthUser | null; // Replace 'any' with your AuthUser type
}

export class UserAPI extends ImplAPI {
  static get route() {
    return '/api/auth/sync-shopify';
  }

  static async post(body: LoginBody) {
    // Alternatively, move the token to the headers here if your backend supports it:
    // const { token, ...restBody } = body;

    return Req<SyncResponse, LoginBody>({
      method: 'POST',
      route: this.route,
      body,
      credentials: 'include',
      // headers: { 'Authorization': `Bearer ${token}` }
    });
  }

  static async patch(body: DefaultAddressBody & { id: AuthUser['id'] }) {
    // Alternatively, move the token to the headers here if your backend supports it:
    // const { token, ...restBody } = body;

    return Req<SyncResponse, DefaultAddressBody>({
      method: 'PATCH',
      route: this.route,
      body,
      credentials: 'include',
      headers: {
        'X-Shopify-Storefront-Access-Token': import.meta.env
          .VITE_SHOPIFY_STOREFRONT_PUBLIC_TOKEN,
      },
    });
  }

  static async get({ signal }: { signal: AbortSignal }) {
    return Req<SyncResponse, { signal: AbortSignal }>({
      method: 'GET',
      route: this.route,
      credentials: 'include',
      signal,
    });
  }

  static async delete() {
    return Req<SyncResponse>({
      method: 'DELETE',
      route: this.route,
      credentials: 'include',
    });
  }
}
